import { API } from "../../api";

export const INTERVAL: (ly?: boolean) => Record<API.StripePriceRecurringInterval, string> = (ly) => ({
  'DAY': `day${ly? 'ly': ''}`,
  "WEEK": `week${ly? 'ly': ''}`,
  'MONTH': `month${ly? 'ly': ''}`,
  'YEAR': `year${ly? 'ly': ''}`,
})
